"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var lodash_throttle_1 = __importDefault(require("lodash.throttle"));
var common_1 = require("stremio/common");
var components_1 = require("stremio/components");
var constants_1 = require("./constants");
var Menu_1 = __importDefault(require("./Menu"));
var Account_1 = __importDefault(require("./Account"));
var Interface_1 = __importDefault(require("./Interface"));
var Player_1 = __importDefault(require("./Player"));
var Info_1 = __importDefault(require("./Info"));
var Settings_less_1 = __importDefault(require("./Settings.less"));
var Settings = function () {
    var routeFocused = (0, common_1.useRouteFocused)();
    var profile = (0, common_1.useProfile)();
    var sectionsContainerRef = (0, react_1.useRef)(null);
    var accountSectionRef = (0, react_1.useRef)(null);
    var interfaceSectionRef = (0, react_1.useRef)(null);
    var playerSectionRef = (0, react_1.useRef)(null);
    var aboutSectionRef = (0, react_1.useRef)(null);
    var sections = (0, react_1.useMemo)(function () { return ([
        { ref: accountSectionRef, id: constants_1.SECTIONS.ACCOUNT },
        { ref: interfaceSectionRef, id: constants_1.SECTIONS.INTERFACE },
        { ref: playerSectionRef, id: constants_1.SECTIONS.PLAYER },
        { ref: aboutSectionRef, id: constants_1.SECTIONS.ABOUT },
    ]); }, []);
    var _a = (0, react_1.useState)(constants_1.SECTIONS.ACCOUNT), selectedSectionId = _a[0], setSelectedSectionId = _a[1];
    var updateSelectedSectionId = (0, react_1.useCallback)(function () {
        var container = sectionsContainerRef.current;
        if (!container)
            return;
        var availableSections = sections.filter(function (section) { return section.ref.current; });
        if (!availableSections.length)
            return;
        var scrollTop = container.scrollTop, clientHeight = container.clientHeight, scrollHeight = container.scrollHeight, offsetTop = container.offsetTop;
        var isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
        if (isAtBottom) {
            setSelectedSectionId(availableSections[availableSections.length - 1].id);
            return;
        }
        var marker = scrollTop + 50;
        var activeSection = availableSections.reduce(function (current, section) {
            var sectionTop = section.ref.current.offsetTop - offsetTop;
            return sectionTop <= marker ? section : current;
        }, availableSections[0]);
        setSelectedSectionId(activeSection.id);
    }, [sections]);
    var onMenuSelect = (0, react_1.useCallback)(function (event) {
        var section = sections.find(function (section) {
            return section.id === event.currentTarget.dataset.section;
        });
        var container = sectionsContainerRef.current;
        section && (container === null || container === void 0 ? void 0 : container.scrollTo({
            top: section.ref.current.offsetTop - container.offsetTop,
            behavior: 'smooth'
        }));
    }, [sections]);
    var onContainerScroll = (0, react_1.useCallback)((0, lodash_throttle_1.default)(function () {
        updateSelectedSectionId();
    }, 50), []);
    (0, react_1.useLayoutEffect)(function () {
        if (routeFocused) {
            updateSelectedSectionId();
        }
    }, [routeFocused]);
    return (react_1.default.createElement(components_1.MainNavBars, { className: Settings_less_1.default['settings-container'], route: 'settings' },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(Settings_less_1.default['settings-content'], 'animation-fade-in') },
            react_1.default.createElement(Menu_1.default, { selected: selectedSectionId, onSelect: onMenuSelect }),
            react_1.default.createElement("div", { ref: sectionsContainerRef, className: Settings_less_1.default['sections-container'], onScroll: onContainerScroll },
                react_1.default.createElement(Account_1.default, { ref: accountSectionRef }),
                react_1.default.createElement(Interface_1.default, { ref: interfaceSectionRef, profile: profile }),
                react_1.default.createElement(Player_1.default, { ref: playerSectionRef, profile: profile }),
                react_1.default.createElement(Info_1.default, { ref: aboutSectionRef })))));
};
var SettingsFallback = function () { return (react_1.default.createElement(components_1.MainNavBars, { className: Settings_less_1.default['settings-container'], route: 'settings' })); };
exports.default = (0, common_1.withCoreSuspender)(Settings, SettingsFallback);
